/**
 * BLOG LISTING PAGE
 *
 * @returns {Promise<void>}
 */
const main = async () => {
   const [
      {default: Vue},
      {ModalPlugin},
      {AjaxMixin},
      ErrorMessages,
      {ValidationProvider, ValidationObserver, extend, configure, localize},
      {required},
      VueScrollTo,
      {default: CategoriesMenu},
      {default: BlogMixin},
   ] = await Promise.all([
      import(/* webpackChunkName: "vue" */ 'vue'),
      import(/* webpackChunkName: "bs-modal" */ 'bootstrap-vue'),
      import(/* webpackChunkName: "global-mixins-ajax" */ '@mymyMixins/ajax'),
      import(/* webpackChunkName: "global-translations-validation" */ '@mymyTranslations/validation'),
      import(/* webpackChunkName: "vee-validate" */ 'vee-validate'),
      import(/* webpackChunkName: "vee-validate-rules" */ 'vee-validate/dist/rules'),
      import(/* webpackChunkName: "vue-scrollto" */ 'vue-scrollto'),
      import(/* webpackChunkName: "blog-categories-menu" */ '@/js/site/blog/components/CategoriesMenu'),
      import(/* webpackChunkName: "blog-pages-mixin" */ '@/js/site/blog/_pages-mixin'),
   ]);

   // for scrolling
   Vue.use(VueScrollTo, {
      offset: - 110,
   });

   // use Bootstrap-Vue components
   Vue.use(ModalPlugin);

   // load our translated form error messages for this page's language
   localize(window.language, ErrorMessages.default[window.language]);

   // add our Vee Validate validators (email is already loaded)
   extend('required', required);

   // tell Vee Validate which classes to apply when a field is valid/invalid, etc
   configure({classes: {invalid: 'is-invalid'}});

   // Create our vue instance
   const vm = new Vue({
      name: 'BlogDetailsPage',
      el: '#blog-details',
      delimiters: ['[[', ']]'],
      mixins: [AjaxMixin, BlogMixin],
      components: {
         'validation': ValidationProvider,
         'validation-observer': ValidationObserver,
         'categories-menu': CategoriesMenu,
      },
      data: {
         lists: {
            search: {
               field: '',
            }
         }
      },

      mounted() {
         // reuse categories we've already queried for and passed to Vue
         if (this.$el.dataset.categories !== '') {
            this.categories = JSON.parse(this.$el.dataset.categories);
         }
      },

      methods: {
         /**
          * Send the user to the search results listing page.
          */
         filterBySearchQuery() {
            if (typeof this.lists.search.field !== 'string' || this.lists.search.field === '') {
               return;
            }

            window.location.href = this.$el.dataset.searchUrl + this.lists.search.field.replace(' ', '+');
         },
      },
   });

   return vm;
}

// Execute async function
main().then( (vm) => {
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
   module.hot.accept();
}